module.exports = __webpack_public_path__ + "static/media/Verify-Email.7a7a30f2.png";